import CutoffTime from '../cut-off-time/cut-off-time';
import styles from '../store-availability.module.scss';

const ShowPickupTime = ({ cutoffTime, timezone }) => {
  return (
    <p
      className={`cat-u-margin-bottom-none cat-u-margin-top-sm fw-bold ${styles['cutoff-time-text']}`}
    >
      <CutoffTime cutoffTime={cutoffTime} timezone={timezone} />
    </p>
  );
};
export default ShowPickupTime;
